import { render } from "./StatisticsTableClique.vue?vue&type=template&id=6b66c3de&scoped=true&ts=true"
import script from "./StatisticsTableClique.vue?vue&type=script&lang=ts"
export * from "./StatisticsTableClique.vue?vue&type=script&lang=ts"

import "./StatisticsTableClique.vue?vue&type=style&index=0&id=6b66c3de&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b66c3de"]])

export default __exports__